// const casahertaAnonymousApiURL = 'http://localhost:3100/api/anonymous';
// const casahertaProtectedApiURL = 'http://localhost:3100/api/protected';

const casahertaAnonymousApiURL = 'https://smbooking-api.skillmedia.be/api/anonymous';
const casahertaProtectedApiURL = 'https://smbooking-api.skillmedia.be/api/protected';
export {
    casahertaAnonymousApiURL,
    casahertaProtectedApiURL,
};
